var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-check"},[(_vm.resultCheck)?_c('result-check-content',_vm._b({attrs:{"layout":"mobile"}},'result-check-content',_vm.resultCheck,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }